import axios from 'axios';


class AppDevice {
    static ServerUrl = '';
    static ExternalServer = '';
    static InstitutionName = '';
    static sharetime = 0;
    static phoneRef = '';
    static WPM = "";
    static async DeviceInit(){
        let config = (await axios.get('/configuracion.json')).data;
        let wpm = (await axios.get('/wp.txt')).data;
        this.WPM = wpm;
        this.ServerUrl = config.ServidorDicom;
        this.ExternalServer = config.ServicorExterno;
        this.InstitutionName = config.NombreInstitucion;
        this.sharetime = config.sharetime;
        this.phoneRef = config.ref;
    }
    static toJson(){
        return {
            ServidorDicom:this.ServerUrl,
            NombreInstitucion:this.InstitutionName,
            ServicorExterno:this.ExternalServer,
            sharetime:this.sharetime,
            ref:this.phoneRef
        }
    }
    static isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
}

export default AppDevice;